// extracted by mini-css-extract-plugin
export default {"button":"Xq+Tl","clickableArea":"_88JZv","icon":"Ts4I7","facebook":"_0JK5y","twitter":"zBNlH","linked-in":"jQVpJ","linkedIn":"jQVpJ","print":"_30oHO"};